import React from 'react';
import type { NotificationState } from '../../types/common';
import useStyles from '../../theme/useStyles';

// The success/error overlay that 18 modules each carried a copy of.
//
//   const { notification, notifyError, dismiss } = useNotification();
//   <Notification notification={notification} onClose={dismiss} />
export interface NotificationProps {
  /** Null hides the overlay entirely. */
  notification: NotificationState | null;
  onClose?: () => void;
  isDarkMode?: boolean;
}

const Notification = ({ notification, onClose, isDarkMode }: NotificationProps) => {
  const s = useStyles(isDarkMode);
  if (!notification) return null;

  const isError = notification.type === 'error';

  return (
    <div style={s.notificationOverlay} onClick={onClose}>
      <div
        style={{ ...s.notificationBox, borderTop: `5px solid ${isError ? s.t.error : s.t.success}` }}
        onClick={(e) => e.stopPropagation()}
      >
        <h4 style={s.notificationTitle}>{notification.title || (isError ? 'Error' : 'Success')}</h4>
        <p style={s.notificationText}>{notification.message}</p>
        <button
          onClick={onClose}
          autoFocus
          style={{ ...s.notificationBtn, backgroundColor: isError ? s.t.danger : s.t.primary }}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default Notification;
